module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoM.3a44ffb.ttf";